import { createAction, createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { createFetchAction, createSaga, fetchInitialState, fetchReducerActions } from 'store/utils';
import { all, takeLatest, put, select } from '@redux-saga/core/effects';
import storage, { deleteCookie, getCookie, keys, setCookie, setSessionCookie } from 'lib/storage';
import * as userApi from 'api/user';
import store, { RootState } from 'store';
import { AppActions, AuthActions } from 'store/actionCreators';
import { IUserProfile } from 'lib/types/userTypes';

export const fetch_profile = createFetchAction('fetch_profile');
export const update_user_currency = createFetchAction('update_user_currency');
export const fetch_user_profile_imgs = createFetchAction('fetch_user_profile_imgs');
export const update_employee_profile = createFetchAction('update_employee_profile');
export const update_employee_password = createFetchAction('update_employee_password');
export const update_user_visibility = createFetchAction('update_user_visibility');
export const update_user_type = createFetchAction('update_user_type');
export const fetch_my_remake_list = createFetchAction('fetch_my_remake_list');
export const edit_my_remake_list = createFetchAction('edit_my_remake_list');
export const fetch_user_indication_list = createFetchAction('fetch_user_indication_list');
export const update_user_indication = createFetchAction('update_user_indication');
export const delete_user_indication = createFetchAction('delete_user_indication');
export const fetch_user_material_list = createFetchAction('fetch_user_material_list');
export const update_user_material = createFetchAction('update_user_material');
export const delete_user_material = createFetchAction('delete_user_material');
export const fetch_user_type_changeable = createFetchAction('fetch_user_type_changeable');
export const create_kpi_login_success = createFetchAction('create_kpi_login_success');

interface InitialState {
  user: IUserProfile | null | any;
  fetchProfile: object | any;
  updateUserCurrecny: object | any;
  userProfileImgs: object | any;
  updateEmployeeProfile: object | any;
  updateEmployeePassword: object | any;
  updateUserVisibility: object | any;
  updateUserType: object | any;
  fetchMyRemakeList: object | any;
  editMyRemakeList: object | any;
  fetchUserIndicationList: object | any;
  updateUserIndication: object | any;
  deleteUserIndication: object | any;
  fetchUserMaterialList: object | any;
  updateUserMaterial: object | any;
  deleteUserMaterial: object | any;
  noNoticeState: boolean;
  fetchUsertypeChangeable: object | any;
  createKpiLoginSuccess: object | any;
}

const { ipcRenderer } = window;

const initialState: InitialState = {
  // 최초 랜딩시 storage값 유무 확인
  user: storage.get(keys.user) || null,
  fetchProfile: { ...fetchInitialState },
  updateUserCurrecny: { ...fetchInitialState },
  userProfileImgs: { ...fetchInitialState },
  updateEmployeeProfile: { ...fetchInitialState },
  updateEmployeePassword: { ...fetchInitialState },
  updateUserVisibility: { ...fetchInitialState },
  updateUserType: { ...fetchInitialState },
  fetchMyRemakeList: { ...fetchInitialState },
  editMyRemakeList: { ...fetchInitialState },
  fetchUserIndicationList: { ...fetchInitialState },
  updateUserIndication: { ...fetchInitialState },
  deleteUserIndication: { ...fetchInitialState },
  fetchUserMaterialList: { ...fetchInitialState },
  updateUserMaterial: { ...fetchInitialState },
  deleteUserMaterial: { ...fetchInitialState },
  noNoticeState: false,
  fetchUsertypeChangeable: { ...fetchInitialState },
  createKpiLoginSuccess: { ...fetchInitialState },
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    set_user: (state, { payload }) => {
      console.log(payload, 'payload SET_USER');
      state.user = payload;
    },
    set_no_notice: (state, { payload }) => {
      console.log(payload, 'payload noNoticeState');
      state.noNoticeState = payload;
    },
    ...fetchReducerActions(fetch_profile, 'fetchProfile', {
      success(state: any, { payload }: PayloadAction<any>) {
        console.log('fetchProfile payload __', payload);
        const profile = payload?.profile;
        if (!profile) return;
        const noRepeatUser = storage.get(keys.user_no_repeat);
        const noNoticeUser = storage.get(keys.user_no_notice);
        const isNoRepeat = noRepeatUser?.includes(profile.email);
        const isNoNotice = noNoticeUser?.includes(profile.email);

        state.user = {
          ...profile,
          company: profile.authority === 0 ? profile.name : profile.adminName,
          isNoRepeat,
          isNoNotice,
        };
        console.log('autoCookie___ ', getCookie(keys.auto_login));
        const {
          userGroupIdx,
          groupCode,
          syncUid,
          email,
          profileImg,
          name,
          countryId,
          accountType,
          currencyCode,
          authority, // Master, Manager, Employee
          canSeeStatistics,
          millingSerialList,
          userTypeIdx,
          provider,
        } = profile;
        // accountType: 1
        // address: null
        // countryId: 116
        // email: "jun@doflab.com"
        // groupCode: "211104789766HPUIBJ"
        // name: "Jun"
        // phone: "1234"
        // phonecode: 116
        // profileImg: null
        // statesId: 1983
        // userGroupIdx: 36
        let userInfo = {
          userGroupIdx,
          groupCode,
          syncUid,
          profileImg,
          email,
          name,
          company: name,
          countryId,
          accountType,
          //TODO: auto login check
          // autoLogin: true,
          autoLogin: Number(getCookie(keys.auto_login)),
          currencyCode,
          authority,
          canSeeStatistics,
          millingSerialList,
          userTypeIdx,
          isNoRepeat,
          isNoNotice,
          provider,
        };
        storage.set(keys.user, userInfo);

        // if (ipcRenderer) {
        //   ipcRenderer.send('loginSuccess', {
        //     accessToken: getCookie(keys.sign_in_token),
        //     // autoLogin: userInfo.autoLogin ? 1 : 0,
        //     autoLogin: userInfo.autoLogin,
        //     email,
        //     name,
        //     groupCode,
        //     groupIdx: userGroupIdx,
        //   });
        // }
      },
    }),
    set_login_success: () => {
      const userInfo = storage.get(keys.user);
      if (!ipcRenderer) return;
      ipcRenderer.send('loginSuccess', {
        accessToken: getCookie(keys.sign_in_token),
        // autoLogin: userInfo.autoLogin ? 1 : 0,
        autoLogin: userInfo.autoLogin,
        email: userInfo.email,
        name: userInfo.name,
        groupCode: userInfo.groupCode,
        groupIdx: userInfo.userGroupIdx,
        userTypeIdx: userInfo.userTypeIdx,
      });
    },

    ...fetchReducerActions(update_user_currency, 'updateUserCurrecny'),
    ...fetchReducerActions(fetch_user_profile_imgs, 'userProfileImgs'),
    ...fetchReducerActions(update_employee_profile, 'updateEmployeeProfile'),
    ...fetchReducerActions(update_employee_password, 'updateEmployeePassword'),
    ...fetchReducerActions(update_user_visibility, 'updateUserVisibility'),
    ...fetchReducerActions(update_user_type, 'updateUserType'),
    ...fetchReducerActions(fetch_my_remake_list, 'fetchMyRemakeList'),
    ...fetchReducerActions(edit_my_remake_list, 'editMyRemakeList'),
    ...fetchReducerActions(fetch_user_indication_list, 'fetchUserIndicationList'),
    ...fetchReducerActions(update_user_indication, 'updateUserIndication'),
    ...fetchReducerActions(delete_user_indication, 'deleteUserIndication'),
    ...fetchReducerActions(fetch_user_material_list, 'fetchUserMaterialList'),
    ...fetchReducerActions(update_user_material, 'updateUserMaterial'),
    ...fetchReducerActions(delete_user_material, 'deleteUserMaterial'),
    ...fetchReducerActions(fetch_user_type_changeable, 'fetchUsertypeChangeable'),
    ...fetchReducerActions(create_kpi_login_success, 'createKpiLoginSuccess'),
  },
});

export const actions: any = slice.actions;

// createSelector
export const userLevelState = (state: RootState) => state.user.user?.authority;
export const isNormalLevelUserSelector = createSelector(userLevelState, item => item === 2);
export const isManagerLevelUserSelector = createSelector(userLevelState, item => item === 1);
export const isMasterLevelUserSelector = createSelector(userLevelState, item => item === 0);
export const userTypeState = (state: RootState) => state.user.user?.userTypeIdx;
export const isClinicUserSelector = createSelector(userTypeState, item => item === 1);

export function* userSaga() {
  yield all([
    takeLatest(
      actions.fetch_profile_request,
      createSaga(actions, 'fetch_profile', userApi.fetchProfile, {
        success: (data: any) => {
          const { groupCode, name, authority, profileImg, email } = data.profile as IUserProfile;
          // 통합 로그인에서 돌아온 후 유저fetch까지 배경화면 어둡게
          if (store.getState().app.dim) {
            AppActions.set_dim(false);
          }
          console.log('data.profile _____ ', data.profile);
          console.log('data.profile email _____ ', email);

          if (authority === 0) {
            AuthActions.set_enrolled_group_codes({
              groupCode,
              nickname: name,
              type: 'manager',
              profileImg: profileImg || '',
              email: email,
            });
          }
        },
      }),
    ),
    takeLatest(
      actions.update_user_currency_request,
      createSaga(actions, 'update_user_currency', userApi.updateUserCurrecny),
    ),
    takeLatest(
      actions.fetch_user_profile_imgs_request,
      createSaga(actions, 'fetch_user_profile_imgs', userApi.fetchUserProfileImgs, {
        success: (data: any) => {
          AuthActions.change_enrolled_group_codes_img(data.profileList);
        },
      }),
    ),
    takeLatest(
      actions.update_employee_profile_request,
      createSaga(actions, 'update_employee_profile', userApi.updateEmployeeProfile),
    ),
    takeLatest(
      actions.update_employee_password_request,
      createSaga(actions, 'update_employee_password', userApi.updateEmployeePassword),
    ),
    takeLatest(
      actions.update_user_visibility_request,
      createSaga(actions, 'update_user_visibility', userApi.updateUserVisibility),
    ),
    takeLatest(
      actions.update_user_type_request,
      createSaga(actions, 'update_user_type', userApi.updateUserType),
    ),
    takeLatest(
      actions.fetch_my_remake_list_request,
      createSaga(actions, 'fetch_my_remake_list', userApi.fetchMyRemakeList),
    ),
    takeLatest(
      actions.edit_my_remake_list_request,
      createSaga(actions, 'edit_my_remake_list', userApi.editMyRemakeList),
    ),
    takeLatest(
      actions.fetch_user_indication_list_request,
      createSaga(actions, 'fetch_user_indication_list', userApi.fetchUserIndicationList),
    ),
    takeLatest(
      actions.update_user_indication_request,
      createSaga(actions, 'update_user_indication', userApi.updateUserIndication),
    ),
    takeLatest(
      actions.delete_user_indication_request,
      createSaga(actions, 'delete_user_indication', userApi.deleteUserIndication),
    ),
    takeLatest(
      actions.fetch_user_material_list_request,
      createSaga(actions, 'fetch_user_material_list', userApi.fetchUserMaterialList),
    ),
    takeLatest(
      actions.update_user_material_request,
      createSaga(actions, 'update_user_material', userApi.updateUserMaterial),
    ),
    takeLatest(
      actions.delete_user_material_request,
      createSaga(actions, 'delete_user_material', userApi.deleteUserMaterial),
    ),
    takeLatest(
      actions.fetch_user_type_changeable_request,
      createSaga(actions, 'fetch_user_type_changeable', userApi.fetchUsertypeChangeable),
    ),
    takeLatest(
      actions.create_kpi_login_success_request,
      createSaga(actions, 'create_kpi_login_success', userApi.createKpiLoginSuccess, {
        success: (data: any) => {
          console.log('[DEBUG] create_kpi_login_success SUCCESS:', data);
        },
        failure: (error: any) => {
          console.log('[DEBUG] create_kpi_login_success FAILURE:', error);
        },
      }),
    ),
    takeLatest(actions.set_login_success, function* () {
      const userInfo = storage.get(keys.user);
      // TODO: MES 사용자인 경우 로그인 했을때 level1 데이터 전송
      if (!!userInfo?.canSeeStatistics) {
        yield put(actions.create_kpi_login_success_request());
      }
    }),
  ]);
}

export default slice.reducer;
